__turbopack_context__.v({
  "Images": "TVPWpW_Images",
  "Info": "TVPWpW_Info",
  "skeleton-loading": "TVPWpW_skeleton-loading",
});
